<template>
  <div class="product-item-order">
    <div class="product-info">
      <div class="product-img">
        <img v-lazy="productImg" alt="" />
      </div>
      <div class="product-des">
        <div class="name_number">
          <div class="name lc-2">
            <img
              class="act-tag"
              v-if="commodity.actTagCode"
              :src="require(`@/assets/img/order/${commodity.actTagCode}.png`)"
              alt=""
            />
            <span>{{ productName[0] }}</span>
          </div>
          <div class="number">X{{ commodity.quantity }}</div>
        </div>
        <div class="version" v-if="productName[1]">
          <div class="detail" v-for="(v, i) in productName[1].split(' | ')" :key="i">
            <span class="line" v-if="i > 0"></span>
            <span>{{ v.trim() }}</span>
          </div>
        </div>
        <div class="price">
          <div class="symbol">￥</div>
          <div class="int">{{ String(salePrice).split('.')[0] }}</div>
          <div class="point">.{{ String(salePrice.toFixed(2)).split('.')[1] }}</div>
        </div>
        <p class="ensure lc-3" v-if="commodity.commodityServiceTips && commodity.commodityServiceTips.length > 0">
          <template v-for="(v, i) in commodity.commodityServiceTips">
            <span class="dot" v-if="i != 0" :key="i">·</span>
            <span :class="i == 0 ? 'ensure-icon' : ''">{{ v.serviceName }}</span>
          </template>
        </p>
      </div>
    </div>
    <template v-if="isGiftCanClick">
      <div v-if="isBundled" class="bundled-info">
        <Package :product="bundledInfo"></Package>
      </div>
      <div v-auto-animate="{ duration: 150, scale: 1, offset: 0 }">
        <div key="deliveryMode" class="gift" v-if="deliveryMode == 4 && gifts && gifts.length > 0">
          <div class="gift-item">赠品：{{ tipPickUpGift }}</div>
        </div>
        <div key="undeliveryMode" class="gift" v-if=" deliveryMode !== 4 && ((gifts && gifts.length > 0) || (productInfo.serviceList && productInfo.serviceList.length > 0))" >
          <div class="gift-item text first" v-if="!confirmOptionalGiftsList.length&&optionGiftsList.length" @click="openGiftsPop()">
            <span class="gift-name">{{ optionalGiftsTitle }}</span>
            <v-icon  name="arrow-right-order" class="g-arrow" />
          </div>
          <div class="gift-item text" :class="{ first: key === 0 && confirmOptionalGiftsList.length }" v-for="(item, key) in giftList" :key="key+Math.random()" @click="openGiftsPop(item)"
            v-track="[ { act: 'show',params: {cfrom: '083|002|02|077', event_id: '083|002|02|077',sku_id: item.giftSkuId,gift_qty: item.num,isno_choose: item.optionalGiftId ? 1 : 0}}]">
            <span class="gift-name">{{ `赠品：${item.name || item.commodityName}` }}</span>
            <span class="tx-num">{{`X${item.num || item.quantity}`}}</span>
            <span v-if="item.marketPrice" class="tx-lt">￥{{item.marketPrice}}</span>
            <span v-if="item.giftType==43||item.giftType==45" class="hour-gift">{{item.giftType==43?"整点加赠":"已购权益"}}</span>
            <img class="vip-label" v-if="item.levelIconWithTextUrl" :src="item.levelIconWithTextUrl"/>
            <v-icon v-if="giftCanClick(item)" name="arrow-right-order" class="g-arrow" />
          </div>
          <div v-if="productInfo.serviceList && productInfo.serviceList.length > 0" class="service-list">
            <div class="gift-item service text" v-for="(item, key) in productInfo.serviceList" :key="key" v-track="[{act: 'show',params: { cfrom: '083|048|02|077', event_id: '083|048|02|077', sku_id: item.commoditySkuId }}]">
              {{ `服务：${item.commodityName}` }}
              <span v-if="item.salePrice || item.marketPrice" class="fc-0">￥{{ item.salePrice || item.marketPrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 我的订单样式 -->
    <template v-else>
      <div class="extra-info">
        <!-- 套餐副商品信息 -->
        <div v-if="isBundled" class="other-item">
          <div class="item" v-for="(item, key) in productInfo.bundledList" :key="key">
            <div class="item-name">{{ `【套餐】${item.commodityName}` }}</div>
            <div class="item-label">{{ `${item.color}` }}</div>
            <div class="item-label item-end">{{ ` X${item.quantity}` }}</div>
          </div>
        </div>
        <!-- 服务信息 -->
        <div class="other-item" v-if="productInfo.serviceList && productInfo.serviceList.length > 0">
          <div class="item" v-for="(item, key) in productInfo.serviceList" :key="key">
            <div class="item-name">{{ `【服务】${item.commodityName}` }}</div>
            <div class="item-label">{{ `￥${item.salePrice || item.marketPrice}` }}</div>
            <div class="item-label item-end">{{ ` X${item.quantity}` }}</div>
          </div>
        </div>
        <!-- 赠品信息 -->
        <div class="other-item" v-if="productInfo.giftList && productInfo.giftList.length > 0">
          <div class="item" :class="{ first: key === 0 }" v-for="(item, key) in productInfo.giftList" :key="key">
            <div class="item-name">
              {{ `【赠品】${item.commodityName}` }}
            </div>
            <!-- 虚拟商品不展示售价 -->
            <div v-if="item.marketPrice && item.giftFlag == 1" class="item-label tx-lt">
              {{ `￥${item.marketPrice} ` }}
            </div>
            <!-- 积分不展示数量 -->
            <div v-if="item.giftFlag != 3" class="item-label item-end">{{ ` X${item.quantity}` }}</div>
          </div>
        </div>
      </div>
    </template>
    <gift-popup @close="closeGiftSelector" :giftParams="giftPopParams" @change="changeGiftSelectedInfo"></gift-popup>
  </div>
</template>
<script>
import create from '../create'
import { mapGetters, mapState } from 'vuex'
import Package from '@/components/package'
import giftPopup from '@/components/gift-popup'
import { formatSpuName } from 'utils/common'
export default create({
  name: 'product-item-order',
  components: {
    Package,
    giftPopup
  },
  props: {
    productInfo: {},
    isGiftCanClick: {
      type: Boolean,
      default: false
    },
    // 购买渠道，0为常规渠道，1表示直播渠道
    purchaseChannel: Number
  },
  data() {
    return {
      giftPopParams: {
        isShow: false,
        pageName: 8
      }
    }
  },
  computed: {
    ...mapState('order-confirm', ['deliveryMode', 'tipPickUpGift']),
    ...mapGetters('order-confirm', ['sysCurTime']),
    commodity() {
      let commodity = this.productInfo.orderCommodity || this.productInfo.orderCommodityVO
      if ((this.$route.query.purchaseChannel == 1 || this.purchaseChannel == 1) && !commodity.actTagCode) {
        commodity.actTagCode = 'live'
      }
      return commodity
    },
    isBundled() {
      return (this.productInfo.bundledList || []).length > 0
    },
    bundledInfo() {
      return {
        skuUnit: this.commodity,
        bundleUnits: this.productInfo.bundledList
      }
    },
    gifts() {
      return this.productInfo.gifts || this.productInfo.giftList || []
    },
    giftList() {
      //过滤可选赠品已选,添加系统时间
      return this.gifts.filter(vv =>
        vv.optionalGiftId && vv.canOptional || !vv.optionalGiftId
      ).map(item => {
        if (item.giftType == 43 && item.hourGiftFlag == 1) item.giftNowTime = this.sysCurTime
        return item
      })
    },
    //可选列表
    optionGiftsList(){
      return this.gifts.filter(item => {
        return item.optionalGiftId
      })
    },
    // 可选列表集合
    optionalGiftsArray() {
      return this.optionGiftsChange(this.optionGiftsList)
    },
    confirmOptionalGiftsList(){
      return this.gifts?.filter(v => v.canOptional) || []
    },
    maxOptionalGiftsNum(){
      return this.optionalGiftsArray.reduce((total, item) => total + item.selectNums || 0, 0)
    },
    optionalGiftsTitle() {
      return `赠品：${this.optionGiftsList.length}选${this.maxOptionalGiftsNum}，已选${this.confirmOptionalGiftsList.length}件`
    },
    // 商品名称 分成两行，一行
    productName() {
      // 969add：套餐商品名称区分展示样式，套餐商品折叠or平铺，折叠展示主商品spu+套餐名，平铺展示主商品sku名称
      if (this.isBundled && this.isGiftCanClick) {
        // 结算页&收银台订单详情弹层适配
        const spuName = formatSpuName(
          this.productInfo.orderCommodityVO?.commodityName || this.productInfo.orderCommodity?.commodityName
        )
        return [spuName + (this.productInfo.orderCommoditySuite?.name || '套餐商品'), null]
      } else {
        const strArr = this.commodity.commodityName.split(/(\s+\d*G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*.)/)
        const str1 = strArr[0].trim()
        let arr2 = strArr.slice(1)
        // 判断sku版本之后紧跟着一个（,而且规格_颜色字符串内存在中文括号时，增加新的名称规则逻辑。
        if (arr2[0] && arr2[0].indexOf('（') === arr2[0].length - 1) {
          if (arr2.join('').split(/(（.*）)/).length > 1) {
            arr2 = this.commodity.commodityName.split(/(\s+\d*G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]（.*）)/).slice(1)
          }
        }
        const str2 = arr2
          .filter(v => v.trim())
          .map(v => v.trim())
          .join(' | ')
        return [str1, str2]
      }
    },
    salePrice() {
      if (this.isBundled && !this.isGiftCanClick) {
        return Number(
          this.productInfo.orderCommoditySuite?.suitePrice ||
          this.productInfo.commodityFinalAmount ||
          this.productInfo.orderCommodity.salePrice
        )
      }
      return Number(this.productInfo.commodityFinalAmount || this.productInfo.orderCommodity.salePrice)
    },
    productImg() {
      return this.productInfo.orderCommoditySuite?.suitePic || this.commodity.commodityImgUrl
    }
  },
  methods: {
    openGiftsPop(giftItem=null) {
      let giftType = 1 //1:可选赠品;2:整点加赠
      if(!giftItem){
        //可选赠品为0时唤起弹窗
        this.setGiftPopParams(giftItem, giftType)
        return 
      }
      if (!this.giftCanClick(giftItem)) return
      if (this.isGiftCanClick && this.giftList && this.giftList.length > 0) {
        // 展示整点加赠弹层
        if (giftItem.giftType == 43) {
          giftType = 2
          this.setGiftPopParams(giftItem,giftType)
        }
        // 可选赠品
        if (giftItem.optionalGiftId) {
          this.setGiftPopParams(giftItem,giftType)
        }
        this.$track({
          cfrom: '083|003|01|077',
          event_id: '083|003|01|077',
          status: 1,
          sku_id: giftItem.giftSkuId,
          gift_form: giftType,//1:可选赠品;2:整点加赠
          isno_choose: giftItem.optionalGiftId ? 1 : 0 
        })
      }
    },
    setGiftPopParams(giftItem,giftType){
      //giftType = 1 1:可选赠品;2:整点加赠
      this.giftPopParams = {
        giftType: giftItem?.giftType||'',
        isShow: true,
        list: giftType == 1 ? this.optionalGiftsArray : this.giftList.filter(vv => vv.giftType == 43),
        pageName: 8
      }
    },
    optionGiftsChange(list) {
      let arr = [...new Set(list.map(v => v.optionalGiftId))]
      let options = []
      arr.forEach(item => {
        let obj = {}
        obj.optionalGiftId = item
        obj.list = list.filter(v => v.optionalGiftId == item)
        obj.selectNums = obj.list[0].allOpCount
        options.push(obj)
      })
      return options
    },
    giftCanClick(giftItem) {
      //41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券,45权益赠品
      if (giftItem.giftType == 43 || giftItem.optionalGiftId) return true
      return false
    },
    closeGiftSelector() {
      this.giftPopParams = {
        isShow: false,
        pageName: 8
      }
    },
    changeGiftSelectedInfo(params = {}) {
      const { optionalList, options } = params
      const selectedGiftIds = {}
      optionalList.map(array => {
        return array.list.filter(item => item.canOptional == 1).map(optionalItem => {
          selectedGiftIds[optionalItem.optionalGiftId]?.length ?
            selectedGiftIds[optionalItem.optionalGiftId].push(optionalItem.id) :
            selectedGiftIds[optionalItem.optionalGiftId] = [optionalItem.id]
        })
      })
      this.$emit('changeGiftsSelected', selectedGiftIds)
    }
  }
})
</script>
<style lang="scss" scoped>
.product-item-order {
  .g-arrow {
    color: #979797;
    height: 24px;
    width: 24px;
  }

  .product-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .product-img {
      background-color: #f9f9f9;
      border-radius: 12px;
      flex-shrink: 0;
      width: 270px;
      height: 270px;

      img {
        width: 270px;
        height: 270px;
        display: block;
        margin: 0 auto;
      }
    }

    .product-des {
      flex: 1;
      margin-left: 33px;

      .name_number {
        display: flex;
        justify-content: space-between;

        .name {
          @include os-font-weight(42, 50);
          font-size: 42px;
          line-height: 1.2;
          margin-right: 33px;
        }

        .act-tag {
          height: 45px;
          margin-right: 20px;
        }

        .number {
          font-size: 36px;
          line-height: 50px;
          color: #888888;
          white-space: nowrap;
          flex-shrink: 0;
        }
      }

      .version {
        font-size: 33px;
        line-height: 33px;
        padding: 15px 0 6px;
        color: #888888;
        display: flex;
        .detail {
          display: flex;
          align-items: center;
          .line {
            display: inline-block;
            width: 1px;
            height: 18px;
            margin: 0 15px;
            background: #888888;
          }
        }
      }

      .price {
        display: flex;
        align-items: baseline;
        padding-top: 21px;

        .symbol,
        .point {
          font-size: 36px;
          line-height: 30px;
          @include os-font-weight-number(36, 50);
        }

        .int {
          @include os-font-weight-number(42, 50);
          font-size: 42px;
          line-height: 42px;
        }
      }

      .ensure {
        margin-top: 27px;
        @include os-font-weight(33, 50);
        font-size: 33px;
        line-height: 47px;
        color: #a97804;
        position: relative;

        span {
          display: inline;
          height: 47px;
          line-height: 47px;

          &.ensure-icon {
            padding-left: 204px;
            background: url(./images/ensure.png) no-repeat;
            background-size: contain;
          }

          &.dot {
            margin: 0 0.25em;
          }
        }
      }
    }
  }

  .bundled-info {
    margin-top: 54px;
  }

  .gift {
    margin-top: 55.5px;
    position: relative;
    .g-arrow {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .text {
      font-size: 36px;
      line-height: 45px;
      color: #999;
      padding-right: 38px;
    }
    .hour-gift{
      min-width: fit-content;
      margin-left: 15px;
      background-color: rgba(241,3,19,0.06);
      color: #F10313;
      font-size: 30px;
      line-height: 48px;
      border-radius: 9px;
      text-align: center;
      padding: 0 10px;
      display: inline-block;
    }
    .vip-label{
      height: 42px;
      margin-left: 15px;
    }
    .optional-title {
      padding-bottom: 36px;
    }
    .gift-item {
      margin-top: 18px;
      position: relative;
      display: flex;
      align-items: center;
      .gift-name{
        display: inline-block;
        padding-right: 5px;
        @include ellipsis();
      }
      &.border {
        margin-top: 30px;
        padding-top: 30px;
        border-top: 0.5px solid #ededed;
      }
      &.bottom-border{
        margin-bottom: 30px;
        padding-bottom: 30px;
        border-bottom: 0.5px solid #ededed;
      }

      &.first {
        margin-top: 0;
      }
      &.service {
        .fc-0 {
          color: #000;
          @include os-font-weight-number(33, 40);
        }
      }
    }
  }
  .tip {
    position: relative;
    font-size: 39px;
    @include os-font-weight(39, 40);
    color: #888888;
    margin-top: -48px;
    margin-bottom: 90px;
    text-align: center;
  }
  .gifts-pop {
    // padding: 0 84px;
    .gift-wrap{
      padding: 48px 33px 18px;
      background: #fafafa;
      border-radius: 30px;
      margin-bottom: 24px;
    }
    .optional-title {
      @include os-font-weight(42, 50);
      line-height: 1.2;
      color: #000;
      font-size: 42px;
      margin-bottom: 42px;
    }

    .gifts-item {
      display: flex;
      align-items: center;
      margin-bottom: 48px;

      &.border {
        padding-top: 48px;
        border-top: 1px solid #ededed;
      }
      &.bottom-border{
        padding-bottom: 48px;
        border-bottom: 1px solid #ededed;
      }

      .gifts-item-select {
        width: 54px;
        height: 54px;
        flex-shrink: 0;
      }
      .gifts-item-left{
        margin-right: 33px;
      }
      .gifts-item-right {
        display: flex;
        align-items: center;
      }

      &.first {
        margin-top: 0;
      }

      .gift-img {
        border-radius: 24px;
        border: 2px solid #f9f9f9;
        position: relative;
        overflow: hidden;
        flex-shrink: 0;
        background-color: #fff;
        .img {
          width: 240px;
          height: 240px;
        }

        .label {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 136px;
          height: 37px;
          line-height: 37px;
          text-align: center;

          .text,
          .bg {
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            border-radius: 0 0 12px 12px;
            word-break: keep-all;
            font-size: 27px;
          }

          &.optional {
            .bg {
              background: linear-gradient(105.2deg, #3360ff 20.64%, #4790ff 83.86%);
              opacity: 0.3;
            }

            .text {
              color: #1d4eff;
            }
          }

          &.vip {
            .bg {
              background: linear-gradient(90deg, rgba(189, 220, 253, 0.56) 4.21%, rgba(126, 196, 255, 0.48));
              backdrop-filter: blur(0.04rem);
            }

            .text {
              color: #456fff;
            }
          }
          &.diamond {
            .bg {
              background: #ECEAF4;
            }

            .text {
              color: #7E71BD;
            }
          }

          &.gold {
            .bg {
              background: linear-gradient(107.6deg, rgba(255, 188, 67, 0.29) 20.23%, rgba(255, 172, 23, 0.48) 86.22%);
            }

            .text {
              color: #804207;
            }
          }

          &.silver {
            .bg {
              background: linear-gradient(90deg, rgba(217, 235, 255, 0.92) 4.21%, rgba(188, 209, 227, 0.88) 100%);
            }

            .text {
              color: #416b8c;
            }
          }

          &.hour {
            .bg {
              background: linear-gradient(105.2deg, #ff3232 20.64%, #ff4762 83.86%);
              opacity: 0.8;
            }

            .text {
              color: #ffffff;
            }
          }
        }
      }

      .gift-des {
        margin-left: 39px;

        .name {
          @include os-font-weight(42, 50);
          font-size: 42px;
          line-height: 51px;
          color: #000000;
        }

        .des {
          font-size: 33px;
          line-height: 42px;
          color: #888888;
          margin-top: 9px;

          &.hour {
            color: #f10313;
            display: flex;
            align-items: center;

            img {
              width: 34px;
              height: 34px;
              margin-right: 12px;
            }
          }
        }

        .price {
          margin-top: 21px;
          display: flex;
          align-items: center;

          .sale-price {
            font-size: 42px;
            @include os-font-weight-number(42, 40);
          }

          .market-price {
            font-size: 36px;
            @include os-font-weight-number(36, 40);
            color: #aaaaaa;
            margin-left: 15px;
            text-decoration: line-through;
          }
        }
      }
    }
  }

  .service {
    font-size: 39px;
    line-height: 39px;
    margin-top: 72px;

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 38px;
    }

    .row:not(:first-child) {
      margin-top: 18px;
    }

    .service-label {
      flex-shrink: 0;
      margin-right: 40px;
    }
  }
  .extra-info {
    .other-item {
      position: relative;

      .item {
        font-size: 33px;
        line-height: 42px;
        color: #888888;
        display: flex;
        justify-content: flex-start;

        .item-name {
          width: fit-content;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 33px;
        }

        .item-label {
          flex-shrink: 0;
          margin-right: 33px;
        }

        .item-end {
          margin-left: auto;
          margin-right: 0px;
        }
      }

      .item {
        margin-top: 18px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .product-item-order .product-info .product-des .name_number .act-tag {
    margin-bottom: 8px;
  }

  .product-item-order .product-info .product-des .ensure .ensure-icon {
    padding-left: 210px;
  }
}

.vivo-fontscale-1 {
  .product-item-order .product-info .product-des .ensure .ensure-icon {
    padding-left: 140px;
  }
}

.vivo-fontscale-2 {
  .product-item-order .product-info .product-des .ensure .ensure-icon {
    padding-left: 160px;
  }
}

.vivo-fontscale-4 {
  .product-item-order .product-info .product-des .ensure .ensure-icon {
    padding-left: 190px;
  }
}
</style>
